export const playlists = [
  {
    id: "pl-high",
    name: "口碑高分精选",
    subtitle: "评分 8.5 分以上，闭眼挑不踩雷",
    accent: "accent",
    items: [
      { title: "城市脉搏", note: "纪实 · 9.0 分 · 节奏舒缓" },
      { title: "雪线之上", note: "冒险 · 8.9 分 · 大银幕质感" },
      { title: "市井烟火", note: "生活 · 8.8 分 · 下饭首选" },
      { title: "驿路长歌", note: "公路 · 8.7 分 · 长镜头" },
      { title: "长风渡月", note: "权谋 · 8.6 分 · 更新中" },
    ],
  },
  {
    id: "pl-northern",
    name: "深夜悬疑片单",
    subtitle: "适合一个人安静看到片尾",
    accent: "secondary",
    items: [
      { title: "雾港迷案", note: "单元案 · 层层反转" },
      { title: "子夜霓虹", note: "黑色电影 · 结局有回甘" },
      { title: "深蓝边界", note: "限定剧 · 一晚上看完" },
      { title: "荒原守望者", note: "末世 · 台词极少" },
    ],
  },
  {
    id: "pl-family",
    name: "陪家人一起看",
    subtitle: "温情、耐看、不吵不闹",
    accent: "primary",
    items: [
      { title: "拾光客栈", note: "群像 · 暖冬故事" },
      { title: "归途信号", note: "家庭 · 克制的和解" },
      { title: "茶馆轶事", note: "年代 · 以小见大" },
      { title: "青禾学堂", note: "青春 · 笑点密集" },
    ],
  },
  {
    id: "pl-bluray",
    name: "画质党必收",
    subtitle: "蓝光 4K 源，值得投屏细看",
    accent: "accent",
    items: [
      { title: "雪线之上", note: "雪山实景 · 层次丰富" },
      { title: "长风渡月", note: "服化道细节拉满" },
      { title: "山海拾遗录", note: "线稿与上色考究" },
      { title: "深蓝边界", note: "低光场景干净" },
    ],
  },
  {
    id: "pl-binge",
    name: "一口气追完",
    subtitle: "篇幅不长，周末两天搞定",
    accent: "secondary",
    items: [
      { title: "深蓝边界", note: "全 6 集" },
      { title: "归途信号", note: "全 16 集" },
      { title: "城市脉搏", note: "全 8 集" },
      { title: "市井烟火", note: "全 36 集 · 可跳看" },
    ],
  },
];